import { SubmitType } from '@urbanx/agx-ui-components';
import GenerationStatus from '../GenerationStatus';

interface AgencyAgreementGeneratingProps {
  generationStatus: GenerationStatus;
  generatingText?: string;
  submitType?: SubmitType;
}

const AgencyAgreementGenerating = ({
  generationStatus,
  generatingText = 'Generating Agreement',
  submitType,
}: AgencyAgreementGeneratingProps) => {
  if (generationStatus === GenerationStatus.Generating) {
    return submitType === SubmitType.GeneratePdf ? generatingText : 'Sending for signing';
  }

  if (generationStatus === GenerationStatus.Generated) {
    return submitType === SubmitType.GeneratePdf ? 'Complete' : 'Sent';
  }
};

export default AgencyAgreementGenerating;
